import api from "@/configs/axios-config";
import type { partSKP } from "./supplierService";

// Import Part V2
export type ImportChildPartBody = {
  child_part_v2_id?: number;
  no: string;
  name: string;
  qty: number;
  material_id: number;
  amount: number;
  ratio: number;
  volume: number;
  consumption: number;
  part_weight: number;
  material_price: number;
  material_cost: number;
  scrap_price: number;
  return_scrap_price: number;
  is_purchase_part: boolean;
  admin: number;
  profit: number;
  percent: number;
  second_tier_process_comment: string;
  child_part_material_second_tier_processes_v2: Array<{
    ms_second_tier_process_id: number;
    cost: number;
  }>;
  other_process_comment: string;
  child_part_material_other_processes_v2: Array<{
    ms_other_process_id: number;
    cost: number;
  }>;
  child_part_processes_v2: Array<{
    ms_cp_process_id: number;
    detail: string;
    qty_1: number;
    cost_per_qty_1: number;
    qty_2: number;
    cost_per_qty_2: number;
    tooling_name: string;
    tooling_cost: number;
  }>;
};

export type ImportPartProcessParam = {
  oem_part_process: ImportPartProcessRow[];
  admin_oem_part_process: number;
  profit_oem_part_process: number;
  spare_part_process: ImportPartProcessRow[];
  admin_spare_part_process: number;
  profit_spare_part_process: number;
};

export type ImportPartOtherProcessParam = {
  oem_other_process: ImportPartOtherProcessRow[];
  admin_oem_part_other_process: number;
  oem_profit_part_other_process: number;
  spare_other_process: ImportPartOtherProcessRow[];
  admin_spare_part_other_process: number;
  spare_profit_part_other_process: number;
};

export type ImportPartProcessRow = {
  ms_process_id: number;
  unit: number;
  price_per_unit: number;
  process_name: string;
  detail: string;
  total_price: number;
};

export type ImportPartOtherProcessRow = {
  ms_process_id: number;
  price: number;
  detail: string;
  process_name: string;
};

export type ImportPartBody = {
  // Step 1 : Add part
  part: partSKP;
  // Step 2 : Add process (From master process id)
  process: {
    ms_second_tier_process_ids: number[];
    ms_other_process_ids: number[];
    ms_cp_process_ids: number[];
    ms_oem_process_ids: number[];
    ms_spare_process_ids: number[];
    ms_oem_other_process_ids: number[];
    ms_spare_other_process_ids: number[];
  };
  //Step 3 : Add Childpart
  child_part: ImportChildPartBody[];
  //Step 4 : Add part process & part other process
  part_process: ImportPartProcessParam;
  part_other_process: ImportPartOtherProcessParam;
  is_migration: boolean;
  is_active: boolean;
};

export const importPart = async (
  body: ImportPartBody,
  supplierCode: string,
) => {
  const response = await api.post(
    `/first-tier-suppliers/import-part/${supplierCode}`,
    body,
  );
  return response.data;
};

// Import Part V1
export type ImportChildPartV1SecondTierProcess = {
  ms_second_tier_process_v1_id: number;
  cost: number;
};

export type ImportChildPartV1OtherProcess = {
  ms_other_process_v1_id: number;
  cost: number;
};

export type ImportChildPartV1OemProcess = {
  ms_oem_process_v1_id: number;
  cost: number;
};

export type ImportChildPartV1SpareProcess = {
  ms_spare_process_v1_id: number;
  cost: number;
};

export type ImportChildPartV1Body = {
  no: string;
  name: string;
  // child_part_info
  qty: number;
  material_id: number;
  material_price: number;
  amount: number;
  ratio: number;
  consumption: number;
  part_weight: number;
  scrap_weight: number;
  // child_part_material_cost
  is_purchased: boolean;
  material_cost: number | null;
  scrap_price: number;
  admin: number;
  profit: number;
  second_tier_process_comment: string;
  second_tier_processes: ImportChildPartV1SecondTierProcess[];
  other_process_comment: string;
  other_processes: ImportChildPartV1OtherProcess[];
  percent: number;
  other_percent: number;
  // child_part_process
  oem_process_comment: string;
  oem_process_admin: number;
  oem_process_profit: number;
  oem_processes: ImportChildPartV1OemProcess[];
  spare_process_comment: string;
  spare_process_admin: number;
  spare_process_profit: number;
  spare_processes: ImportChildPartV1SpareProcess[];
  cp_oem_admin: number;
  cp_oem_profit: number;
  cp_spare_admin: number;
  cp_spare_profit: number;
};

export type ImportPartV1Body = {
  part: partSKP;
  child_part: ImportChildPartV1Body[];
  is_migration: boolean;
  is_active: boolean;
};

// mock — backend endpoint ยังอยู่ระหว่างทำ
export const importPartV1 = async (
  body: ImportPartV1Body,
  supplierCode: string,
): Promise<void> => {
  const response = await api.post(
    `/first-tier-suppliers/import-part-v1/${supplierCode}`,
    body,
  );
  return response.data;
};
